'use client'

import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { CarouselTest } from '@dustin-web/microsite-components/src/carousel-test/carousel'
import { ListItemRenderer } from '@dustin-web/product-components/src/product-list'
import { Button } from '@dustin-web/microsite-components/src/button'
import { ProductCardGallerySkeleton } from '@dustin-web/microsite-components/src/skeleton'
import { withGods } from './hocs/products-with-data-hoc'
import { WrappedComponentProps } from './types/types'

const ProductsSlider = ({ button, products, isLoading }: WrappedComponentProps) => {
  const btnText = button && button[0]?.properties?.link?.text
  const btnUrl = button && button[0]?.properties?.link?.url
  const isBtnTextEmpty = btnText === btnUrl
  const { translate } = useTranslations()

  const sortedProducts = products
    ?.filter(product => product.searchResultProduct?.price?.isCampaign)
    .concat(products?.filter(product => !product.searchResultProduct?.price?.isCampaign))

  if (isLoading) {
    return (
      <div className="row d-flex">
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
        <div className="col-12 col-md-3">
          <ProductCardGallerySkeleton />
        </div>
      </div>
    )
  } else if (sortedProducts && sortedProducts?.length) {
    return (
      <>
        <CarouselTest
          type="startpage"
          dots={true}
          dotMode="full-width"
          partialVisible={true}
          fullWidth={true}
          colorTheme={'gray'}
          list={sortedProducts?.map(
            (r: any, key: number) =>
              r.searchResultProduct && (
                <ListItemRenderer
                  key={r.ticket + key}
                  imagePriority={false}
                  product={r.searchResultProduct}
                  ticket={r.ticket}
                  listType={'stripped'}
                  gallerySizeClasses={'slider-card u-px-8'}
                  digitalDataOrigin={'topSellersContentBlock'}
                  digitalIndex={key}
                />
              )
          )}
        />
        {!!btnText && !!btnUrl && (
          <div className="d-flex justify-content-end">
            <Button
              primary
              icon="arrow-right"
              iconSize="16"
              text={(isBtnTextEmpty && translate('ShowAll')) || btnText}
              href={btnUrl}
              link={true}
              className="align-self-end"
            />
          </div>
        )}
      </>
    )
  } else {
    return <p>No products avalible</p>
  }
}

const ProductsSLiderWithGoods = withGods(ProductsSlider)

export const ProductsSliderBlock = ProductsSLiderWithGoods
